import { FunctionComponent, lazy, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'

const PsychologistSearch = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsyAliveSearch'
    ),
)

const PsyaliveProfessionalFullProfile = lazy(
  () =>
    import(
      '@/modules/Attendance/submodules/ScheduledPsyAlive/pages/PsyaliveProfessionalFullProfile'
    ),
)

const routes = [
  <Route
    path="/atendimento-agendado-psicologo/busca-profissional"
    key="/atendimento-agendado-psicologo/busca-profissional"
    exact
    component={PsychologistSearch}
  />,
  <Route
    path="/atendimento-agendado-psicologo/busca-profissional/perfil-profissional/:professionalId"
    key="/atendimento-agendado-psicologo/busca-profissional/perfil-profissional/:professionalId"
    exact
    component={PsyaliveProfessionalFullProfile}
  />,
]

const ScheduledPsyAliveRoutes: FunctionComponent = () => (
  <Fragment>
    <Switch>{routes}</Switch>
  </Fragment>
)

export default ScheduledPsyAliveRoutes
